/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { IOSScreenProto } from './iosscreen-proto';

export class IOSScreensProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IOSScreensProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIOSScreensProto(
    bb: flatbuffers.ByteBuffer,
    obj?: IOSScreensProto,
  ): IOSScreensProto {
    return (obj || new IOSScreensProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIOSScreensProto(
    bb: flatbuffers.ByteBuffer,
    obj?: IOSScreensProto,
  ): IOSScreensProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IOSScreensProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  main(obj?: IOSScreenProto): IOSScreenProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new IOSScreenProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  screens(index: number, obj?: IOSScreenProto): IOSScreenProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new IOSScreenProto()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  screensLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startIOSScreensProto(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMain(builder: flatbuffers.Builder, mainOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, mainOffset, 0);
  }

  static addScreens(builder: flatbuffers.Builder, screensOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, screensOffset, 0);
  }

  static createScreensVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startScreensVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endIOSScreensProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIOSScreensProto(
    builder: flatbuffers.Builder,
    mainOffset: flatbuffers.Offset,
    screensOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    IOSScreensProto.startIOSScreensProto(builder);
    IOSScreensProto.addMain(builder, mainOffset);
    IOSScreensProto.addScreens(builder, screensOffset);
    return IOSScreensProto.endIOSScreensProto(builder);
  }
}
